const ls = {
  set: (key, item, expiry = null) => {
    let expiryTime = null;

    // Setting expiry time if provided
    if (expiry) {
      const now = Date.now();
      expiryTime = now + expiry;
    }

    // Construct data to be stored
    const data = {
      item,
      expiry: expiryTime,
    };

    window.localStorage.setItem(key, JSON.stringify(data));
  },
  get: (key) => {
    let data = window.localStorage.getItem(key);

    // Return when no data
    if (!data) {
      return null;
    }

    const { item, expiry } = JSON.parse(data);

    // If expiry is available then check current time has surpassed that
    // Remove from localStorage when time has surpassed

    if (expiry && Date.now() > expiry) {
      window.localStorage.removeItem(key);

      return null;
    }

    return item;
  },
  remove: (key) => {
    let data = window.localStorage.getItem(key);

    if (data) {
      window.localStorage.removeItem(key);
    }
  },
};

export default ls;
